import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp } from "react-icons/fa";
import { Row, Col } from 'react-bootstrap';
import Loader from '../../../components/Loader/Loader';

import { postUpdateDescription } from '../../../apiservices/ApiServices';
import { DescriptionvalidationSchema } from '../../../schemas';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const DescriptionFrm = ({ details, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [previewSrc, setPreviewSrc] = useState('');
    const [editorReady, setEditorReady] = useState(false);

    const initialValues = {
        shortDescription: details?.short_description || '',
        detailedDescription: details?.incident_detail_description,
        immediateActionsTaken: details?.immediate_action_taken || '',
        reportedOn: details?.reported_on || '',
        reportedBy: details?.reported_by || '',
        createdBy: details?.text_created_by || '',
    };

    useEffect(() => {
        setPreviewSrc(details?.description_image?.image_url)
    }, [details]);

    const postUpdateDescriptions = async (postdata) => {
        setLoadings(true);
        try {
            const res = await postUpdateDescription(postdata);
            console.log('res', res.data);
            toast.success(res.data.message);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoadings(false);
        }

    };

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: DescriptionvalidationSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            if (values.detailedImage instanceof File) {
                formData.append('images[]', values.detailedImage);
            }
            formData.append('incident_header_id', details?.header_id);
            formData.append('header_id', details?.header_id);
            formData.append('short_description', values.shortDescription);
            formData.append('incident_detail_description', values.detailedDescription);
            formData.append('immediate_action_taken', values.immediateActionsTaken);
            formData.append('reported_on', values.reportedOn);
            formData.append('reported_by', values.reportedBy);
            formData.append('created_by', values.createdBy);
            console.log('formData', formData)
            postUpdateDescriptions(formData);
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    useEffect(() => {
        setFieldValue('shortDescription', details?.short_description);
        setFieldValue('detailedDescription', details?.incident_detail_description);
        setFieldValue('immediateActionsTaken', details?.immediate_action_taken);
        setEditorReady(true);
    }, [details, setFieldValue]);

    return (
        <>
            <div className="form-box">
                <div className="GroupList fieldset">
                    <div className='toggle-button'>
                        <h2 className="listTitle">Description</h2>
                        <div className='btnColaps'><FaChevronUp /></div>
                    </div>
                    <div className="formsBox subFilds Detailed new">
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <Row>
                                <Col md={6} className='rd-100'>
                                    <div className='previewimgs'>
                                        {previewSrc && (
                                            <img id="preview" src={previewSrc} alt="Preview" style={{ maxWidth: '100%', marginTop: '10px' }} />
                                        )}
                                    </div>
                                </Col>
                                <Col md={6} className='rd-100'>
                                    <div className="form-box">
                                        <div className={Array.isArray(details?.risk_matrix) && details.risk_matrix.length > 0 ? 'fieldset intl' : 'fieldset'}>
                                            <h1>{Array.isArray(details?.risk_matrix) && details.risk_matrix.length > 0 ? 'Initial Immediate Actions Taken' : 'Immediate Actions Taken'}</h1>
                                            <div className="formsBox">
                                                <div className="form-group">
                                                    <div dangerouslySetInnerHTML={{ __html: values.immediateActionsTaken }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={12} className='rd-100'>
                                    <div className="form-group">
                                        <label>Short Description <span className="req">*</span></label>
                                        {editorReady && (
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={values.shortDescription}
                                                config={{
                                                    toolbar: ['undo', 'redo', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                                                }}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFieldValue('shortDescription', data);
                                                }}
                                            />
                                        )}

                                        {errors.shortDescription && touched.shortDescription ? (
                                            <p className='errormsg'>{errors.shortDescription}</p>
                                        ) : null}
                                    </div>
                                </Col>
                                <Col md={12} className='rd-100'>
                                    <div className="form-group">
                                        <label>Detailed Description <span className="req">*</span></label>
                                        {editorReady && (
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={values.detailedDescription}
                                                config={{
                                                    toolbar: ['undo', 'redo', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                                                }}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFieldValue('detailedDescription', data);
                                                }}
                                            />
                                        )}

                                        {errors.detailedDescription && touched.detailedDescription ? (
                                            <p className='errormsg'>{errors.detailedDescription}</p>
                                        ) : null}
                                    </div>
                                </Col>
                                <Col md={4} style={{ opacity: 0.7 }}>
                                    <div className="form-group">
                                        <label>Reported On</label>
                                        <input type="date"
                                            id="reportedOn"
                                            name="reportedOn"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.reportedOn}
                                            disabled={true}
                                            readOnly={true}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Reported By</label>
                                        <input
                                            type='text'
                                            id="reportedBy"
                                            name="reportedBy"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.reportedBy}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4} style={{ opacity: 0.7 }}>
                                    <div className="form-group">
                                        <label>Created By</label>
                                        <input
                                            type='text'
                                            id="createdBy"
                                            name="createdBy"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.createdBy}
                                            disabled={true}
                                            readOnly={true}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <div className='button-boxs grid pt-3 pb-3'>
                                <button type='submit' className='btn btn-orange'>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default DescriptionFrm